// Spanish for the SOS Field app: sales. Keys are the English text exactly as written in the code.
// "Sales", "Home", "Back", "Try again", "(optional)" and "Finding the address…" come from the other files.
export default {
  // pages/field/marketing.vue
  'Customers and estimates': 'Clientes y presupuestos',
  'Find a customer, make an estimate and have the contract signed.':
    'Busca un cliente, haz un presupuesto y consigue la firma del contrato.',
  'New lead': 'Nuevo cliente potencial',
  'Search by name, phone or address': 'Busca por nombre, teléfono o dirección',
  'Loading leads': 'Cargando clientes potenciales',
  'No name': 'Sin nombre',
  '1 estimate': '1 presupuesto',
  '{count} estimates': '{count} presupuestos',
  'No matching leads': 'No hay clientes potenciales con esa búsqueda',
  'No leads yet': 'Todavía no hay clientes potenciales',
  'Try another name, phone or street.': 'Prueba otro nombre, teléfono o calle.',
  'Tap “New lead” to add your first customer.':
    'Toca “Nuevo cliente potencial” para agregar tu primer cliente.',

  // components/field/sales/OffPanel.vue
  'Sign in to use Sales': 'Inicia sesión para usar Ventas',
  'Sign in with your phone number and your PIN first.':
    'Primero entra con tu número de teléfono y tu PIN.',
  'Go to sign in': 'Ir a iniciar sesión',
  'Sales is off for you': 'Ventas no está activado para ti',
  'The office turns Sales on for each worker. Ask the office to turn it on for you.':
    'La oficina activa Ventas para cada trabajador. Pide a la oficina que te lo active.',
  'Check again': 'Revisar otra vez',

  // components/field/sales/LeadSheet.vue
  'First name': 'Nombre',
  'Last name': 'Apellido',
  Phone: 'Teléfono',
  Email: 'Correo electrónico',
  'Street address': 'Calle y número',
  'Use my location': 'Usar mi ubicación',
  City: 'Ciudad',
  State: 'Estado',
  'ZIP code': 'Código postal',
  Notes: 'Notas',
  'What does the customer need?': '¿Qué necesita el cliente?',
  'Save lead': 'Guardar cliente potencial',
  'Lead saved': 'Cliente potencial guardado',
  'Type a name or a phone number.': 'Escribe un nombre o un teléfono.',
  'A lead with this phone number already exists.':
    'Ya hay un cliente potencial con este número de teléfono.',
  'Open that lead': 'Abrir ese cliente potencial',
  'Could not find the address here': 'No se encontró la dirección aquí',
  'Type the address instead.': 'Mejor escribe la dirección.',

  // pages/field/sales/lead/[id].vue
  Lead: 'Cliente potencial',
  'All leads': 'Todos los clientes potenciales',
  Contact: 'Contacto',
  'Tap to call': 'Toca para llamar',
  'Tap to email': 'Toca para mandar un correo',
  'Open in maps': 'Abrir en el mapa',
  'No phone, email or address saved.':
    'No hay teléfono, correo ni dirección guardados.',
  Estimates: 'Presupuestos',
  'New estimate': 'Nuevo presupuesto',
  'Estimate #{number}': 'Presupuesto #{number}',
  Contract: 'Contrato',
  'Updated {date}': 'Actualizado el {date}',
  'No estimates yet': 'Todavía no hay presupuestos',
  'Tap “New estimate” to price the job.':
    'Toca “Nuevo presupuesto” para ponerle precio al trabajo.',

  // components/field/sales/NewEstimateSheet.vue
  'Pick a template to start from, or start blank.':
    'Elige una plantilla para empezar, o empieza en blanco.',
  'Blank estimate': 'Presupuesto en blanco',
  'Type every line yourself.': 'Escribe tú cada línea.',
  'Loading templates': 'Cargando plantillas',
  '1 line': '1 línea',
  '{count} lines': '{count} líneas',
  'Could not make the estimate': 'No se pudo hacer el presupuesto',

  // components/field/sales/EstimateStatus.vue (estimate statuses)
  New: 'Nuevo',
  'Sent to customer': 'Enviado al cliente',
  'Follow up': 'Dar seguimiento',
  'Second follow up': 'Segundo seguimiento',
  'On hold': 'En espera',
  'Needs signature': 'Falta firmar',
  Signed: 'Firmado',
  Rejected: 'Rechazado',

  // pages/field/sales/estimate/[id].vue
  Estimate: 'Presupuesto',
  Title: 'Título',
  'For example: Kitchen water damage': 'Por ejemplo: Daño por agua en cocina',
  Status: 'Estado',
  'Price lines': 'Líneas de precio',
  'Line {number}': 'Línea {number}',
  'Remove line {number}': 'Quitar línea {number}',
  'Remove line {number}?': '¿Quitar la línea {number}?',
  'What is it?': '¿Qué es?',
  'For example: Remove wet drywall': 'Por ejemplo: Quitar drywall mojado',
  Quantity: 'Cantidad',
  Unit: 'Unidad',
  each: 'cada uno',
  'Price for each': 'Precio por unidad',
  'No price yet': 'Falta el precio',
  'Add line': 'Agregar línea',
  Total: 'Total',
  Terms: 'Condiciones',
  'Payment, warranty, what is not included…':
    'Pago, garantía, lo que no está incluido…',
  'Type what this line is for.': 'Escribe para qué es esta línea.',
  'Quantity must be more than 0.': 'La cantidad tiene que ser mayor que 0.',
  'Type a unit (for example: each, hour, sq ft).':
    'Escribe una unidad (por ejemplo: pieza, hora, pie²).',
  'Type a price.': 'Escribe un precio.',
  'Add at least one line.': 'Agrega por lo menos una línea.',
  'Check line {number}.': 'Revisa la línea {number}.',
  'Line {number}: {problem}': 'Línea {number}: {problem}',
  'Estimate saved': 'Presupuesto guardado',
  'Someone else changed this estimate. Reload it to see the latest, then make your changes again.':
    'Otra persona cambió este presupuesto. Vuelve a cargarlo para ver lo más nuevo y luego haz tus cambios otra vez.',
  Reload: 'Volver a cargar',
  'Your changes will be lost. Reload anyway?':
    'Se van a perder tus cambios. ¿Volver a cargar de todos modos?',
  'You have changes that are not saved. Leave anyway?':
    'Tienes cambios sin guardar. ¿Salir de todos modos?',
  'Save estimate': 'Guardar presupuesto',
  Saved: 'Guardado',
  Save: 'Guardar',
  'Not saved yet': 'Sin guardar',
  'This estimate has a contract.': 'Este presupuesto ya tiene contrato.',
  'When the customer says yes, make the contract and have it signed.':
    'Cuando el cliente diga que sí, haz el contrato y pide que lo firme.',
  'Open contract': 'Abrir contrato',
  'No contract templates yet. Ask the office to add one.':
    'Todavía no hay plantillas de contrato. Pide a la oficina que agregue una.',
  'Contract template': 'Plantilla de contrato',
  'Choose a contract': 'Elige un contrato',
  'Save the estimate first.': 'Primero guarda el presupuesto.',
  'Create contract': 'Crear contrato',
  'Could not make the contract': 'No se pudo hacer el contrato',

  // pages/field/sales/contract/[id].vue
  'Not sent yet': 'Todavía no se envía',
  'Waiting for the customer to sign': 'Esperando la firma del cliente',
  'The customer said no': 'El cliente dijo que no',
  Canceled: 'Cancelado',
  Expired: 'Vencido',
  'Waiting to sign': 'Falta que firme',
  'Opened it': 'Ya lo abrió',
  'Said no': 'Dijo que no',
  'The customer': 'El cliente',
  'The contract is signed!': '¡El contrato está firmado!',
  'Everyone signed. The office gets a copy.':
    'Todos firmaron. La oficina recibe una copia.',
  'Back to Sales': 'Volver a Ventas',
  'The customer has not signed yet. Give them the phone to sign now.':
    'El cliente todavía no firma. Dale el teléfono para que firme ahora.',
  'Continue signing on this phone': 'Seguir firmando en este teléfono',
  'The customer got a link to sign. This page shows when they sign.':
    'El cliente recibió un enlace para firmar. Esta página te avisa cuando firme.',
  Refresh: 'Actualizar',
  'Fill in before sending': 'Llena esto antes de enviar',
  'Each answer saves by itself. Fields with * are required.':
    'Cada respuesta se guarda sola. Los campos con * son obligatorios.',
  Saving: 'Guardando',
  Done: 'Listo',
  'Who signs': 'Quién firma',
  'Our company signs by itself': 'Nuestra empresa firma sola',
  'Gets a copy': 'Recibe una copia',
  'No email or phone': 'Sin correo ni teléfono',
  'How will the customer sign?': '¿Cómo va a firmar el cliente?',
  'Fill in first: {fields}': 'Primero llena: {fields}',
  'Customer signs now on this phone': 'El cliente firma ahora en este teléfono',
  'Give the phone to the customer. They sign with their finger.':
    'Dale el teléfono al cliente. Firma con el dedo.',
  'Send by email': 'Enviar por correo',
  'The customer signs later from the email.':
    'El cliente firma después desde el correo.',
  'No email for {name}. Ask the office to add it.':
    'No hay correo de {name}. Pide a la oficina que lo agregue.',
  'Send by text message': 'Enviar por mensaje de texto',
  'The customer gets a text with a link to sign.':
    'El cliente recibe un mensaje con un enlace para firmar.',
  'No phone for {name}. Ask the office to add it.':
    'No hay teléfono de {name}. Pide a la oficina que lo agregue.',
  'Send the contract to {name} by email?':
    '¿Enviar el contrato a {name} por correo?',
  'Send the contract to {name} by text message?':
    '¿Enviar el contrato a {name} por mensaje de texto?',
  'Contract sent by email': 'Contrato enviado por correo',
  'Contract sent by text message': 'Contrato enviado por mensaje de texto',
  'Contract ready to sign': 'Contrato listo para firmar',
  'Could not send the contract': 'No se pudo enviar el contrato',
} as Record<string, string>
